/* eslint-disable unicorn/no-this-assignment */
import isPlainObject from 'lodash/isPlainObject';

import api from 'atg/api/API';
import { BET_TIPS, TOP_INFO } from 'atg/constants/PopupMenuTypes';
import { isTouch } from 'atg/utils/device';
import StickyTemplate from 'atg/vendor/StickyTemplate/1.0/StickyTemplate';
import { getText } from 'shared/utils/Text';

let current;

const $ = window.$;
const fadeDuration = 100;
const closeCurrent = () => current && current.close();

export default class PopupMenu {
  static closeCurrent = closeCurrent;

  constructor(type, position, items, onClose) {
    closeCurrent();

    current = this;

    this.onItemGroupRollOver = this.onItemGroupRollOver.bind(this);
    this.onItemGroupRollOut = this.onItemGroupRollOut.bind(this);

    const $overlay = (this.$overlay = $('<div class="overlay"/>'));
    const $container = (this.$container = StickyTemplate.jq('popup-menu'));

    this.setItems(items);
    this.position = position;
    this.onClose = onClose;
    this.type = type;

    if (this.type === TOP_INFO) {
      $container.addClass('top-info-popup-menu');
    } else if (this.type === BET_TIPS) {
      $container.addClass('bet-tips-popup-menu');
    }

    const $parent = (this.$parent = $('body'));

    $parent.append($overlay);
    $parent.append($container);
    $container.fadeIn(fadeDuration);

    $overlay.event('click', () => this.close());

    let left = position.left;
    const cw = $container.width();
    const ww = $(window).width();
    if (left + cw > ww) {
      left = ww - cw;
    }

    let top = position.top;
    const ch = $container.height();
    const wh = window.innerHeight;
    if (top + ch > wh) {
      top = wh - ch;
    }

    $container.css({
      left: left,
      top: top,
    });

    $(window).event('scroll', closeCurrent);
  }

  setItems = function (items) {
    this.items = items;

    const openState = this.getOpenState();

    this.$container.empty();
    this.addItems(items, this.$container);
    this.setOpenState(openState);
  };

  getOpenState() {
    const openState = [];

    let $parent = this.$container;
    let index = -1;

    do {
      const $itemGroup = $parent.find('> .item > .item-group.open');
      const $item = $itemGroup.closest('.item');
      index = $item.index();

      if (index !== -1) {
        openState.push(index);
        $parent = $itemGroup;
      }
    } while (index > -1);

    return openState;
  }

  setOpenState(openState) {
    this.$container.find('.item-group').removeClass('open');
    let $parent = this.$container;

    for (const index of openState) {
      const $item = $parent.find(`> *:eq(${index})`);
      const $itemGroup = $item.find('> .item-group');

      this.showItemGroup($itemGroup);
      $parent = $itemGroup;
    }
  }

  getIndexPathForItem(itemCallback) {
    const cb =
      typeof itemCallback === 'function'
        ? itemCallback
        : item => item === itemCallback;

    const itemsByIndexPath = this.getItemsByIndexPath();

    for (const indexPathString in itemsByIndexPath) {
      const item = itemsByIndexPath[indexPathString];

      if (cb(item)) {
        return indexPathString.split('-');
      }
    }
  }

  getItemForIndexPath = function (indexPath) {
    const itemsByIndexPath = this.getItemsByIndexPath();
    const indexPathString = indexPath.join('-');

    return itemsByIndexPath[indexPathString];
  };

  getItemsByIndexPath = function () {
    const itemsByIndexPath = {};

    this.addItemsByIndexPath(this.items, itemsByIndexPath);
    return itemsByIndexPath;
  };

  addItemsByIndexPath = function (items, object, keyPrefix = '') {
    for (const [index, item] of items.entries()) {
      object[keyPrefix + index] = item;
      if (item.items) {
        this.addItemsByIndexPath(item.items, object, `${keyPrefix + index}-`);
      }
    }
  };

  close = function (callback) {
    if (current === this) {
      current = null;
    }

    this.$overlay.unevent('click');

    if (this.onClose) {
      this.onClose();
    }

    this.$container.fadeOut(fadeDuration, () => {
      this.$container.remove();
      this.$overlay.remove();
      if (callback) {
        callback();
      }
    });

    $(window).unevent('scroll', closeCurrent);
  };

  addItems(items, $container) {
    const internationalTrack = api.betInformation.hasInternationalTrack();

    for (const item of items) {
      let $item;
      let $element;
      let $a;

      const isPresetReduction =
        item.view && item.view.isInstanceOf('view-preset-reduction');

      if (!isPlainObject(item)) {
        // any non-object is a delimiter
        $item = StickyTemplate.jq('popup-menu-delimiter');
      } else {
        $item = item.$item = StickyTemplate.jq('popup-menu-item', {
          '.title': item.title,
        });

        if (item.locked) {
          $item.addClass('locked');
          $item.event('click', () => {
            this.close();
            item.onUpgradePress();
          });
          $element = StickyTemplate.jq('popup-menu-lock', {
            '%subscription-notice-text%': getText(
              'atg-popup-menu-subscription-notice',
            ),
          });
          $item.append($element);
          $container.append($item);
          continue;
        }

        if (item.loading) {
          $a = $item.find('a');
          $a.addClass('loading');
        }

        if (item.href) {
          $a = $item.find('a');
          $a.prop({
            href: item.href,
            target: '_blank',
          });
        }

        $item.event(
          'click',
          function (event) {
            event.stopImmediatePropagation();
            this.popupMenu.pressItem(this.item);
          }.bind({ popupMenu: this, item: item }),
        );

        if (item.color) {
          $item.addClass(item.color);
        }

        if (item.selected) {
          $item.addClass('selected');
        }

        if (item.deletable) {
          $element = StickyTemplate.jq('popup-menu-delete');
          $item.append($element);
          if (!item.deleteEnabled) {
            $element.addClass('disabled');
          } else {
            $element.event(
              'click',
              function (event) {
                event.stopImmediatePropagation();
                this.popupMenu.deleteItem(this.item);
              }.bind({ popupMenu: this, item: item }),
            );
          }
        }

        if (item.togglable) {
          $element = StickyTemplate.jq('popup-menu-toggle');
          $item.append($element);

          if (item.toggled) {
            $item.addClass('toggled');
          }

          if (!item.toggleEnabled) {
            $element.addClass('disabled');
          } else {
            $element.event(
              'click',
              function (event) {
                event.stopImmediatePropagation();
                this.popupMenu.toggleItem(this.item);
              }.bind({ popupMenu: this, item: item }),
            );
          }
        }

        const itemDisabled = isPresetReduction
          ? internationalTrack
          : item.disabled;

        if (itemDisabled) {
          $item.addClass('disabled');
        }

        if (item.addable) {
          $item.addClass('addable');
          $element = StickyTemplate.jq('popup-menu-add');
          $item.append($element);
          // Attach a view to this item so it can check blocked state on click
          // TODO - explore if there's a cleaner way to do this
          item.siblingItemView = items[0].view;
        }

        if (item.items) {
          $element = StickyTemplate.jq('popup-menu-expand');
          $item.append($element);

          const $groupContainer = StickyTemplate.jq('popup-menu-item-group');

          if (!isTouch()) {
            $item.event('mouseover', this.onItemGroupRollOver);
            $item.event('mouseout', this.onItemGroupRollOut);
          }

          $item.append($groupContainer);

          this.addItems(item.items, $groupContainer);
        }
      }
      $container.append($item);
    }
  }

  toggleShowItemGroup($itemGroup) {
    if ($itemGroup.hasClass('open')) {
      this.hideItemGroup($itemGroup);
    } else {
      this.showItemGroup($itemGroup);
    }
  }

  showItemGroup($itemGroup) {
    $itemGroup.addClass('open');
    const iw = $itemGroup.width();
    const ww = $(window).width();
    const offsetTop = $itemGroup.offset().top;

    $itemGroup.css({
      maxHeight: $(window).height() - offsetTop,
    });

    if ($itemGroup.offset().left + iw > ww - 5) {
      $itemGroup.css({
        left: ww - 5 - iw - $itemGroup.parent().offset().left,
        top: 10,
      });
    }
  }

  hideItemGroup = $itemGroup => $itemGroup.removeClass('open');

  onItemGroupRollOver(event) {
    const $item = $(event.currentTarget);
    this.showItemGroup($item.find('.item-group'));
  }

  onItemGroupRollOut(event) {
    const $item = $(event.currentTarget);
    this.hideItemGroup($item.find('.item-group'));
  }

  pressItem(item) {
    if (isTouch()) {
      item.$item.siblings('.item').find('> .item-group').removeClass('open');
    }

    if (item.items) {
      if (isTouch()) {
        this.toggleShowItemGroup(item.$item.find('> .item-group'));
      }
    } else if (item.onPress) {
      if (item.addable && item.siblingItemView.showAlertWhenLocked()) {
        return;
      }
      item.onPress();
    }
  }

  deleteItem(item) {
    if (item.view.showAlertWhenLocked()) {
      return;
    }
    if (item.onDelete) {
      item.onDelete();
    }
  }

  toggleItem(item) {
    if (item.view.showAlertWhenLocked()) {
      return;
    }

    item.toggled = !item.toggled;

    if (item.toggled) {
      item.$item.addClass('toggled');
    } else {
      item.$item.removeClass('toggled');
    }

    if (item.onToggle) {
      item.onToggle();
    }
  }
}
